import logger from '@helpers/logger'
import useMessage from '@hooks/useMessage'
import {useMutate} from 'apollo-hooks'
import gql from 'graphql-tag'

export default function useAdjustQuantityCart({
  cartItemId,
  setLoading
}: {
  cartItemId: string
  setLoading: (loading: boolean) => void
}) {
  const mutate = useMutate()
  const showMessage = useMessage()
  const submit = async amount => {
    if (!amount) return
    setLoading(true)
    try {
      await mutate({
        mutation: gql`
          mutation cartV3UpdateCartItemAmount($cartItemId: ID!, $amount: Float!) {
            updateCartItemAmount(cartItemId: $cartItemId, amount: $amount) {
              _id
              amount
            }
          }
        `,
        variables: {cartItemId, amount},
        refetchQueries: ['getCartDetails', 'getPreferencesForResume']
      })
    } catch (error) {
      showMessage('Lo sentimos, no se pudo actualizar el producto')
      logger.error('Error UpdateCartItemAmount cartv3', error)
    } finally {
      setLoading(false)
    }
  }

  return submit
}
